import {useQuery} from 'react-query'
import {EditModalForm} from './EditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getProjectsFilter} from '../core/_requests'
import {ProjectStatus} from '../core/_models'
import {useAuth} from '../../../../auth'

const EditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {currentUser} = useAuth()

  const {
    isLoading,
    data: project,
    error,
    status
  } = useQuery(
    `${QUERIES.PROJECTS}-project-${itemIdForUpdate}`,
    () => {
      const companyId = (currentUser?.last_company_id) ? +currentUser.last_company_id : 0;
      return getProjectsFilter(companyId, {project_id: itemIdForUpdate, take: 0, skip: 1})
    },
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return (
      <EditModalForm
        isProjectLoading={isLoading}
        response={{
          status_id: ProjectStatus.active.id,
          created_at: new Date(),
        }}
        status={status}
      />
    )
  }

  if (!isLoading && !error && project) {
    return (
      <EditModalForm
        isProjectLoading={isLoading}
        response={project?.data}
        status={status}
      />
    )
  }

  return null
}

export {EditModalFormWrapper}
